export default "__VITE_ASSET__8lIXgfJ5__"